import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { TuiAutoFocusModule } from '@taiga-ui/cdk';
import { TuiButtonModule, TuiDialogContext } from '@taiga-ui/core';
import { TuiInputModule } from '@taiga-ui/kit';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { selectSessionUser } from '@us/web/auth/data-access';
import { OrderMember } from '@us/web/shared/data-access';

@Component({
    selector: 'us-enter-name-dialog',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, TuiInputModule, TuiButtonModule, TranslocoModule, TuiAutoFocusModule],
    templateUrl: './enter-name-dialog.component.html',
    styleUrls: ['./enter-name-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnterNameDialogComponent {
    private readonly context = inject(POLYMORPHEUS_CONTEXT) as TuiDialogContext<OrderMember>;
    private readonly fb = inject(FormBuilder);
    private readonly store = inject(Store);

    readonly form: FormGroup;

    constructor() {
        const user = this.store.selectSignal(selectSessionUser)();
        this.form = this.fb.group({
            id: [user.id, [Validators.required]],
            name: [user.name, [Validators.required]]
        });
    }

    onSubmit() {
        if (this.form.valid) {
            this.context.completeWith(this.form.getRawValue());
        }
    }
}
